import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { formatMoney, url } from "@/utils";
import { CourseDto } from "@/data/dtos/course.dto";
import { Link } from "react-router-dom";

interface ItemsData {
  course: CourseDto;
  quantity: number;
  price: number;
  discount: number;
  tax: number;
  createdAt: Date;
}

export default function CourseSalesTable({ items }: { items: ItemsData[] }) {
  // Sütun tanımlamaları
  const columns: GridColDef[] = [
    {
      field: "course",
      headerName: "Atölye Adı",
      flex: 1,
      valueGetter: (params: any) => {
        console.log(params);
        return params.title;
      },
    },
    {
      field: "buyer",
      headerName: "Satın Alan Kişi",
      flex: 0.5,
      renderCell: (params) => {
        return (
          <Link
            to={url("Admin.Users.View", { id: params.row.buyer._id })}
            className="link"
          >
            {params.row.buyer.name} {params.row.buyer.surname}
          </Link>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Satış Tarihi",
      flex: 0.5,
      type: "date",
      valueFormatter: (params: Date) => {
        const date = new Date(params);
        return date.toLocaleDateString("tr-TR");
      },
    },
    { field: "quantity", headerName: "Satış Adedi", flex: 0.1, type: "number" },
    {
      field: "price",
      headerName: "Vitrin Fiyatı/Adet",
      flex: 0.5,
      type: "number",
      valueFormatter: (params: any) => formatMoney(params),
    },
    {
      field: "discount",
      headerName: "İndirim Tutarı / Adet",
      flex: 0.5,
      type: "number",
      valueFormatter: (params: any) => formatMoney(params),
    },
    {
      field: "listPrice",
      headerName: "İndirimli Satış Tutarı/Adet",
      flex: 0.5,
      type: "number",
      valueFormatter: (params: any) => formatMoney(params),
    },
    {
      field: "tax",
      headerName: "KDV/Adet",
      flex: 0.5,
      type: "number",
      valueFormatter: (params: any) => formatMoney(params),
    },
  ];

  // `id` zorunlu bir alan olduğu için `groupedData`'ya `id` ekliyoruz
  const rows = items.map((item: any, index) => ({
    id: index, // Her satıra benzersiz bir ID
    course: item.course,
    buyer: item.buyer,
    quantity: item.quantity,
    price: item.price,
    listPrice: item.price - item.discount,
    tax: item.tax,
    discount: item.discount,
    createdAt: item.createdAt,
  }));

  const pageSizeOptions = [25, 50, 100];

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Atölye Birim Performansı</h2>
      <div style={{ height: "auto", width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={pageSizeOptions}
          checkboxSelection
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: pageSizeOptions[0] },
            },
          }}
        />
      </div>
    </div>
  );
}
